// ** Routes Imports
import ProfileRoutes from "./Profile"
import OrganizationRoutes from "./Organization"
import ApplicationRoutes from "./Application"
import InstructionRoutes from "./Instruction"
import ActiveAccountRoutes from "./ActiveAccount"

// ** Document title
const TemplateTitle = "%s - CyberID Myaccount"

// ** Default Route
const DefaultRoute = "/profile"

// ** Merge Routes
const Routes = [...ProfileRoutes, ...OrganizationRoutes, ...ApplicationRoutes, ...InstructionRoutes, ...ActiveAccountRoutes]

export { DefaultRoute, TemplateTitle, Routes }
